import { render, staticRenderFns } from "./shareIcon.vue?vue&type=template&id=2ffa62b2"
import script from "./shareIcon.vue?vue&type=script&lang=js"
export * from "./shareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports